export const Config = {
  headers: {
    'Content-Type': 'application/json',
    'Accept': '*/*'
  },

  baseUrl: import.meta.env.VITE_BACKEND_BASE_URL,
  account: 'account/',
  settings: 'settings',
  user: 'user/',

  payment: 'payment/',
  session: 'session',
  verify: 'verify',

  search: 'search',
  assign: 'assign',

  locations: 'locations',
  location: 'location/',

  categories: 'categories',
  product: 'product/',
  variant: 'variant/',
  inventory: 'inventory',
  metafield: 'metafield',
  productSearch: 'product_search/',
  productScan: 'product_scan',

  suppliers: 'suppliers/',
  supplier: 'supplier/',

  shippingMethods: 'shipping_methods',
  paymentMethods: 'payment_methods',
  paymentMethod: 'payment_method/',
  paymentTerms: 'payment_terms',
  paymentTerm: 'payment_term/',
  taxSettings: 'tax_settings',
  taxSetting: 'tax_setting/',

  assignments: 'assignments',
  assignment: 'assignment',

  thresholds: 'thresholds',
  threshold: 'threshold',

  address: 'address',

  purchaseOrders: 'purchase_orders',
  purchaseOrder: 'purchase_order/',
  download: 'download/',

  warehouseReceivingOrders: 'warehouse_receiving_orders',
  warehouseReceivingOrder: 'warehouse_receiving_order/',

  upload: 'upload',
  process: 'process',

  order: 'order',
  orders: 'orders/',

  incomplete: 'incomplete',
  shipments: 'shipments',

  suggestedPurchaseOrder: 'suggested_purchase_order',
}